import { intervalToDuration } from 'date-fns';

export const formatWaitingDuration = (since) => {
  const { days = 0, hours = 0, minutes = 0 } = intervalToDuration({
    start: new Date(since),
    end: Date.now(),
  });
  const totalHours = days * 24 + hours;
  if (totalHours <= 0) return `${minutes}min`;
  return `${totalHours}h ${String(minutes).padStart(2, '0')}min`;
};
